const BEVERAGES = [
  {
    group: "Espresso & Coffee",
    items: [
      "Espresso",
      "Macchiato",
      "Cortado",
      "Cappuccino",
      "Americano",
      "Lattes",
      "Flavored Lattes",
      "Mocha",
      "White Chocolate Mocha",
    ],
  },
  {
    group: "Tea & Warm Sips",
    items: [
      "Chai Tea",
      "London Fog",
      "Assorted Specialty Teas",
      "Hot Chocolate",
      "Flavored Steamers",
    ],
  },
  {
    group: "Cold & Signature",
    items: [
      "Italian Sodas",
      "House-Made Lemonades",
      "Magic Mushroom Latte",
      "Lotus Spritzers",
    ],
  },
];

const BITES = [
  {
    group: "Savory Bites",
    items: [
      "Italian Paninis",
      "Breakfast Burritos",
      "Stuffed Waffles",
      "Wraps",
      "Mini Sandwiches",
      "Charcuterie Bites",
    ],
  },
  {
    group: "Sweet Treats",
    items: [
      "Biscotti",
      "Scones",
      "Pie Slices",
      "Homemade Ding Dongs",
      "Cupcakes",
    ],
  },
];

const MenuGroup = ({ group, items }) => (
  <div data-testid={`menu-group-${group.toLowerCase().split(" ")[0]}`}>
    <h3 className="font-serif-display text-2xl font-semibold text-[#FAF7F2] mb-5 pb-3 border-b border-[#594D42]">
      {group}
    </h3>
    <ul className="space-y-3">
      {items.map((name) => (
        <li key={name} className="flex items-center gap-3 text-[#D4C3B3]">
          <span className="w-1.5 h-1.5 rounded-full bg-[#8B5E3C] shrink-0" />
          <span className="text-[#FAF7F2]/90">{name}</span>
        </li>
      ))}
    </ul>
  </div>
);

export const MenuHighlights = () => {
  return (
    <section id="menu" data-testid="menu-section" className="py-24 md:py-32 bg-[#2C2621]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <p className="uppercase tracking-[0.2em] text-xs font-semibold text-[#D4C3B3] mb-4">
            Our Menu
          </p>
          <h2 className="font-serif-display text-4xl md:text-5xl font-semibold text-[#FAF7F2] tracking-tight">
            Crafted to delight every guest
          </h2>
          <p className="mt-5 text-[#D4C3B3] text-lg leading-relaxed">
            Gourmet beverages from our exclusive, hand-selected Monorail beans, paired with
            house-made treats — fully customizable, including dairy-free and dietary-friendly
            options.
          </p>
        </div>

        <p className="uppercase tracking-[0.2em] text-xs font-semibold text-[#8B5E3C] mb-8">
          Handcrafted Beverages
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-12 mb-16">
          {BEVERAGES.map((m) => (
            <MenuGroup key={m.group} {...m} />
          ))}
        </div>

        <p className="uppercase tracking-[0.2em] text-xs font-semibold text-[#8B5E3C] mb-8">
          House-Made Bites & Treats
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-12">
          {BITES.map((m) => (
            <MenuGroup key={m.group} {...m} />
          ))}
        </div>

        <p className="font-serif-display text-2xl md:text-3xl text-[#FAF7F2] text-center mt-20 italic">
          Customize our fare to fit your foodie mood.
        </p>
      </div>
    </section>
  );
};
